import React, { useEffect, useState } from "react";
import Header from "./Header";

const ExploreAICourses = () => {
  const [data, setData] = useState([]);
  const [search, setSearch] = useState(""); // 🔍 filter state

  useEffect(() => {
    const category = "Explore AI Courses";

    fetch(`https://new.aitoolsbenefits.com/api/content/${encodeURIComponent(category)}`)
      .then(res => res.json())
      .then(result => setData(result))
      .catch(err => console.error(err));
  }, []);

  // 🔍 FILTER LOGIC
  const filteredData = data.filter(item =>
    `${item.title || ""} ${item.subTitle || ""} ${item.paragraph || ""}`
      .toLowerCase()
      .includes(search.toLowerCase())
  );

  return (
    <>
      <Header />

      <section className="bg-light py-5">
        <div className="container">
          <div className="bg-white shadow-sm rounded-4 p-4 p-md-5">

            {/* 🔍 SEARCH INPUT */}
            <div className="mb-4">
              <input
                type="text"
                className="form-control"
                placeholder="Search AI Courses..."
                value={search}
                onChange={(e) => setSearch(e.target.value)}
              />
            </div>

            {filteredData.length === 0 && (
              <p className="text-center text-muted">
                No content found
              </p>
            )}

            {filteredData.map((item, i) => (
              <div key={i} className="mb-5">

                {/* TITLE */}
                <h4 className="fw-bold mb-3 text-center">
                  {item.title}
                </h4>

                {/* IMAGE */}
                {item.image && (
                  <img
                    src={
                      item.image.startsWith("http")
                        ? item.image
                        : `https://new.aitoolsbenefits.com${item.image}`
                    }
                    alt={item.title}
                    className="img-fluid rounded-4 mb-3 w-100"
                    style={{ maxHeight: "300px", objectFit: "cover" }}
                  />
                )}

                {/* SUB TITLE */}
                {item.subTitle && (
                  <p className="text-muted mb-2">
                    {item.subTitle}
                  </p>
                )}

                {/* PARAGRAPH */}
                {item.paragraph && (
                  <p className="fs-6 lh-lg">
                    {item.paragraph}
                  </p>
                )}

              </div>
            ))}

          </div>
        </div>
      </section>
    </>
  );
};

export default ExploreAICourses;
